export enum License {
  CCL = "ccl",
  NoCopyright = "NoCopyright",
  PublicDomain = "PD",
  VL = "VL"
}
